import { PageHeader } from '@fukuri-admins/ui/common';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { ContactMethods } from '~/features/ContactMethods';
import styles from './styles.module.scss';

/**
 * お問い合わせ Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='お問い合わせ' />
      <main className={styles.body}>
        <ContactMethods />
      </main>
    </div>
  </div>
);
